import React from 'react';
import PropTypes from 'prop-types';

import TenantView, {
    TenantDxGrid,
    TenantMobileGrid,
    TenantForm,
    TenantFormDialog
} from '../TenantView';

const getDxGrid = (DxGrid) => (DxGrid || <TenantDxGrid/>);

const getMobileGrid = (MobileGrid) => (MobileGrid || <TenantMobileGrid/>);

const getFormDialog = (Form) => (
    <TenantFormDialog form={Form || <TenantForm />} />
);
const getDataTableView = ({breakpoint, tenantDxGrid, tenantMobileGrid}) => {
    if (breakpoint.down('md')) {
        return getMobileGrid(tenantMobileGrid);
    }

    return getDxGrid(tenantDxGrid);
};

export const getTenantView = (props) => {
    const {
        breakpoint,
        tenantDxGrid,
        tenantMobileGrid,
        tenantForm,
        tenantFormDialog,
        tenantView,
        viewName,
        viewStyles,
        params,
    } = props;

    if (tenantView) return tenantView;

    return (
        <TenantView
            key={viewName}
            viewName={viewName}
            viewStyles={viewStyles}
            params={params}
            dataTable={getDataTableView({
                breakpoint,
                tenantDxGrid,
                tenantMobileGrid,
            })}
            formDialog={tenantFormDialog || getFormDialog(tenantForm)}
        />
    );
};

getTenantView.propTypes = {
    breakpoint: PropTypes.object.isRequired,
    tenantDxGrid: PropTypes.node,
    tenantForm: PropTypes.node,
    tenantFormDialog: PropTypes.node,
    tenantMobileGrid: PropTypes.node,
    tenantView: PropTypes.node,
    viewName: PropTypes.string,
    viewStyles: PropTypes.object,
};
